import { QUALITY_ORDER } from './CloudQuality.js';

export class AdaptiveQualityController {

	constructor( options = {} ) {

		this.targetFrameMs = options.targetFrameMs ?? 16.7;
		this.degradeAfter = options.degradeAfter ?? 24;
		this.upgradeAfter = options.upgradeAfter ?? 240;
		this.slowThreshold = options.slowThreshold ?? 1.18;
		this.fastThreshold = options.fastThreshold ?? 0.78;
		this.quality = options.quality ?? 'balanced';
		this.enabled = options.enabled ?? false;
		this.smoothedFrameMs = this.targetFrameMs;
		this.slowFrames = 0;
		this.fastFrames = 0;

	}

	setQuality( quality ) {

		if ( ! QUALITY_ORDER.includes( quality ) ) throw new RangeError( `Unknown quality: ${ quality }` );
		this.quality = quality;
		this.slowFrames = 0;
		this.fastFrames = 0;

	}

	sample( frameMs ) {

		if ( ! Number.isFinite( frameMs ) || frameMs <= 0 ) return null;

		this.smoothedFrameMs += ( frameMs - this.smoothedFrameMs ) * 0.08;

		if ( ! this.enabled ) return null;

		if ( this.smoothedFrameMs > this.targetFrameMs * this.slowThreshold ) {

			this.slowFrames ++;
			this.fastFrames = 0;

		} else if ( this.smoothedFrameMs < this.targetFrameMs * this.fastThreshold ) {

			this.fastFrames ++;
			this.slowFrames = 0;

		} else {

			this.slowFrames = Math.max( 0, this.slowFrames - 1 );
			this.fastFrames = Math.max( 0, this.fastFrames - 1 );

		}

		const currentIndex = QUALITY_ORDER.indexOf( this.quality );

		if ( this.slowFrames >= this.degradeAfter && currentIndex > 0 ) {

			this.setQuality( QUALITY_ORDER[ currentIndex - 1 ] );
			return this.quality;

		}

		if ( this.fastFrames >= this.upgradeAfter && currentIndex < QUALITY_ORDER.length - 1 ) {

			this.setQuality( QUALITY_ORDER[ currentIndex + 1 ] );
			return this.quality;

		}

		return null;

	}

}
